import React, { useState, useMemo, useCallback, useEffect } from 'react';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import NativeSelect from '@material-ui/core/NativeSelect';
import { useSelector } from 'react-redux';
import GeneralTable from './GeneralTable';
import matrixData from './JsonFiller/matrixData.json';
import employeeData from './JsonFiller/new.json';
import { CommonConfig } from '../../../../config/common-config';
import token from '../../../../config/token';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../../components/loaderpopup/success';
import ErrorPopUp from '../../../../components/loaderpopup/error';
import { makeStyles } from '@material-ui/core/styles';

function useForceUpdate() {
    let [value, setState] = React.useState(true);
    return () => setState(!value);
}

function PremissionTable() {
    const tokens = token();
    const initialError = {
        isError: false,
        errorType: 0,
    };
    const useStyles = makeStyles((theme) => ({
        disableBtn: {
            color: '#bbb !important',
            background: '#cecece !important',
            padding: '6px 40px !important',
            fontFamily: 'Rubik',
            textTransform: 'none !important',
            pointerEvents: 'none'
        }
    }))
    const classes = useStyles();
    const [AllImcs, setAllImcs] = useState([]);
    const [AllImcEmp, setAllImcEmp] = useState([]);
    const [selectedImc, setselectedImc] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isError, setisError] = useState(initialError);
    const [errorDetails, seterrorDetails] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const matrix = matrixData;
    const currentEmployee = employeeData[0];
    const [data, setData] = useState(matrix);
    const [employee, setEmployee] = useState(currentEmployee);
    const [updateState, setUpdateState] = useState([]);
    const [tableColumn, setColumn] = useState([]);
    const [tableDatas, setTableData] = useState([]);
    const [compareDesignation, setCompareDesignation] = useState([data[0].roleCategory, data[0].roleText[0].roleText]);
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[0].branchName;
    const [buttonDissable, setButtonDissable] = useState(true);

    let forceUpdate = useForceUpdate();

    useEffect(() => {
        setLoading(true);
        {
            (usertype === "Admin") ? (
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/roles-admin/${tennantnameValue}`, tokens)
                    .then((response) => {
                        // console.log("response66", response.data);

                        setData(response.data);
                    })
                    .then((response) => {
                        setLoading(false);
                    })
                    .catch((error) => {
                        //console.log(error);
                    })
            )
                :
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/roles-super-admin`, tokens)
                    .then((response) => {
                        setData(response.data);
                    })
                    .then((response) => {
                        setLoading(false);
                    })
                    .catch((error) => {
                        //console.log(error);
                    });
        }

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, tokens)
            .then((response) => setAllImcs(response.data.content))
            .catch((error) => {
                //console.log(error);
            });

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${tennantnameValue}?page=0&size=600&sort=empId,desc`, tokens)
            .then((response) => setAllImcEmp(response.data.content))
            .catch((error) => {
                //console.log(error);
            });

        setData(matrix);
    }, [tokens]);

    // const changeEmployee = value => {
    //   /// Contact API for Featching New Employee Data
    //   const employee = employeeData.find(e => {
    //     return e.empId.toString() === value.toString()
    //   })
    //   if (employee) {
    //     ////console.log("HEHEHE",employee);
    //     setEmployee(employee)
    //   }
    // }

    const getEmplDetails = (empId) => {
        ////console.log("empId:",empId.target.value)
        let url = ""
        if (selectedImc === "itec") {
            url = CommonConfig.dev.baseUrl + "/api/auth/itec-emp-roles/" + empId.target.value
        } else {
            url = CommonConfig.dev.baseUrl + "/api/auth/emp-roles/" + selectedImc + "/" + empId.target.value
        }
        setButtonDissable(false);
        axios
            .get(url, tokens)
            .then((response) => setEmployee(response.data[0]))

            .catch((error) => {
                //console.log(error);
            })

    }

    const getEmplDetailsCore = (empId) => {
        setButtonDissable(false);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/emp-roles/${tennantnameValue}/${empId.target.value}`, tokens)
            .then((response) => setEmployee(response.data[0]))

            .catch((error) => {
                //console.log(error);
            })

    }

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((dataImc) => <option value={dataImc.dbName}>{dataImc.dbName}</option>);
        return OptionList;
    };
    const allImcEmpOptions = (ImcEmp) => {

        if (selectedImc === "itec") {
            const OptionList = ImcEmp.map((ImcEmpData) => <option value={ImcEmpData.itecEmpId}>{ImcEmpData.itecEmpId} - {ImcEmpData.firstName} {ImcEmpData.lastName}</option>);
            return OptionList;
        } else {
            const OptionList = ImcEmp.map((ImcEmpData) => <option value={ImcEmpData.empId}>{ImcEmpData.empId} - {ImcEmpData.firstName} {ImcEmpData.lastName}</option>);
            return OptionList;
        }
    };

    const errorsDisplay = () => {
        if (isError.isError) {
            // if (isError.errorType === 1) return <Alert severity="error"> {errorDetails.message}</Alert>;
            if (isError.errorType === 1) {
                return (<div>{errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={errorDetails.message} />) : null} </div>);
            }
            if (isError.errorType === 2) {
                return (
                    <div>
                        {/* <Alert severity="error"> */}
                        {errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={' '} />) : null}
                        {errorDetails.map((dataerr, i) => (
                            <div>
                                {i + 1}) {dataerr}
                            </div>
                        ))}
                        {/* </Alert> */}
                    </div>
                );
            }
            if (isError.errorType === 3) {
                return (
                    <div>
                        {/* <Alert severity="success">
                            <AlertTitle>SUCCESS</AlertTitle> Created Successfully
                        </Alert> */}
                        {successpop ? (<SuccessPopUp open={successpop} showSuccess={successpop} title="Matrix updated successfully" />) : null}
                    </div>

                );
            }

            if (isError.errorType === 4) {
                return (
                    <div>
                        {/* <Alert severity="info">
                            <AlertTitle>Connecting to server.........please wait</AlertTitle>
                        </Alert> */}
                        {showLoader ? (<LoaderPopUp showLoader={showLoader} />) : null}
                    </div>
                );
            }

            return (
                <div>
                    {/* <Alert severity="info">
                        <AlertTitle>Something went wrong....try again</AlertTitle>
                    </Alert> */}
                    {errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title="Something went wrong....try again" />) : null}
                </div>
            );
        }
        return false;
    };

    const save = () => {
        setShowLoader(true);
        const updateError = {
            isError: true,
            errorType: 4,
        };
        setisError(updateError);
        let url = ""
        if (usertype === "Admin") {
            url = CommonConfig.dev.baseUrl + "/api/auth/emp-roles/" + tennantnameValue
        }
        else if (selectedImc === "itec") {
            url = CommonConfig.dev.baseUrl + "/api/auth/itec-emp-roles"
        } else {
            url = CommonConfig.dev.baseUrl + "/api/auth/emp-roles/" + selectedImc
        }
        axios
            .post(url, updateState[0], tokens)
            .then((response) => {
                const updateError1 = {
                    isError: true,
                    errorType: 3,
                };
                setSuccessPop(true);
                setisError(updateError1);
                setTimeout(() => {
                    setSuccessPop(false);
                    // props.history.push('/menu/ClientColleagueView');
                }, 1500);
                setTimeout(() => {
                    // props.history.push('/menu/ClientColleagueView');
                }, 3000);
            })
            .catch((err) => {
                if (err.response) {
                    const errResult = err.response.data;

                    if (Object.prototype.hasOwnProperty.call(errResult, 'errors')) {
                        setErrorPop(true);
                        const updateError2 = {
                            isError: true,
                            errorType: 2,
                        };
                        setisError(updateError2);
                        const errorAll = err.response.data.errors.map((data1) => `${data1.field} ${data1.defaultMessage}`);
                        seterrorDetails(errorAll);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 2000);
                    } else {
                        setErrorPop(true);
                        const updateError3 = {
                            isError: true,
                            errorType: 1,
                        };
                        setisError(updateError3);
                        seterrorDetails(err.response.data);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 2000);
                    }
                    //  alert(err.response.data.message);
                } else if (err.request) {
                    // client never received a response, or request never left
                } else {
                    // anything else
                }
            });
    };
    const setImc = (e) => {
        setselectedImc(e.target.value);
        setLoading(true);
        if ((e.target.value).toString() == "itec") {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee`, tokens)
                .then((response) => {
                    setAllImcEmp(response.data.content);
                })
                .catch((error) => {
                    //console.log(error);
                });

            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/roles-super-admin_indivdualMatrix`, tokens)
                .then((response) => {
                    //console.log("response66", response.data[0]);

                    setData(response.data);
                })
                .then((response) => {
                    setLoading(false);
                })
                .catch((error) => {
                    //console.log(error);
                })

        } else {

            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${e.target.value}`, tokens)
                .then((response) => {
                    setAllImcEmp(response.data.content);
                })
                .catch((error) => {
                    //console.log(error);
                });

            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/roles-admin/${e.target.value}`, tokens)
                .then((response) => {
                    // console.log("response344", response.data[0]);

                    setData(response.data);
                })
                .then((response) => {
                    setLoading(false);
                })
                .catch((error) => {
                    //console.log(error);
                })
        }
    };
    const updateData = useCallback(
        (updated, roleCategory, roleText, value) => {
            setEmployee((emplDetail) => {
                const datax = emplDetail;
                let roleTextIndex = -1;
                let featureIndex = -1;
                let subfeatureIndex = -1;

                roleTextIndex = datax.roleText.findIndex((role) => role.roleText === roleText);
                if (roleTextIndex !== -1) {
                    featureIndex = datax.roleText[roleTextIndex].feature.findIndex((role) => role.featureText === updated.features);
                    if (featureIndex !== -1) {
                        subfeatureIndex = datax.roleText[roleTextIndex].feature[featureIndex].subFeatures.findIndex(
                            (role) => role.subFeatureText === updated.sub_features
                        );
                    }
                }

                if (roleTextIndex !== -1 || featureIndex !== -1 || subfeatureIndex !== -1) {
                    datax.roleText[roleTextIndex].feature[featureIndex].subFeatures[subfeatureIndex].isActive = value;

                    const updater = [
                        {
                            roleCategory: datax.roleCategory,
                            empId: employee.empId,
                            roleText: [
                                {
                                    ...datax.roleText[roleTextIndex],
                                    feature: [
                                        {
                                            ...datax.roleText[roleTextIndex].feature[featureIndex],
                                            subFeatures: [datax.roleText[roleTextIndex].feature[featureIndex].subFeatures[subfeatureIndex]],
                                        },
                                    ],
                                },
                            ],
                        },
                    ];

                    setUpdateState((state) => {
                        let updateRoleCategoryIndex = -1;
                        let updateRoleTextIndex = -1;
                        let updateFeatureIndex = -1;
                        let updateSubfeatureIndex = -1;

                        updateRoleCategoryIndex = state.findIndex((role) => {
                            return role.roleCategory === roleCategory;
                        });

                        if (updateRoleCategoryIndex !== -1) {
                            updateRoleTextIndex = state[updateRoleCategoryIndex].roleText.findIndex((role) => role.roleText === roleText);
                            if (updateRoleTextIndex !== -1) {
                                updateFeatureIndex = state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature.findIndex(
                                    (role) => role.featureText === updated.features
                                );
                                if (updateFeatureIndex !== -1) {
                                    updateSubfeatureIndex = state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                        updateFeatureIndex
                                    ].subFeatures.findIndex((role) => role.subFeatureText === updated.sub_features);

                                    if (updateSubfeatureIndex !== -1) {
                                        state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                            updateFeatureIndex
                                        ].subFeatures.splice(updateSubfeatureIndex, 1, updater[0].roleText[0].feature[0].subFeatures[0]);
                                    } else {
                                        state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                            updateFeatureIndex
                                        ].subFeatures.push(...updater[0].roleText[0].feature[0].subFeatures);
                                    }
                                } else {
                                    state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature.push(
                                        ...updater[0].roleText[0].feature
                                    );
                                }
                            } else {
                                state[updateRoleCategoryIndex].roleText.push(...updater[0].roleText);
                            }
                        } else {
                            state.push(...updater);
                        }

                        return state;
                    });
                }

                return datax;
            });
        },
        [employee]
    );

    const update = useCallback(
        (index, value, roleCategory, roleText) => {
            setTableData((tabData) => {
                const datatab = tabData;
                datatab[index].individual = value;
                updateData(datatab[index], roleCategory, roleText, value);
                return [...datatab];
            });
        },
        [updateData]
    );

    useMemo(() => {
        const column = [];
        column.push(
            {
                Header: 'Features',
                accessor: 'features',
            },
            {
                Header: 'Sub Features',
                accessor: 'sub_features',
            },
            {

                // Header: employee.roleText[0].roleText,
                Header: employee.roleText[0].roleText === '' ? "Current Designation" + employee.roleText[0].roleText : "Current Designation : " + employee.roleText[0].roleText,
                accessor: 'individual',
                Cell: ({ row }) => {
                    //console.log(row)
                    return (
                        <Checkbox
                            color="primary"
                            checked={row.values.individual}
                            onChange={(e) => {
                                update(row.index, e.target.checked, row.original.roleCategory, row.original.roleText);
                            }}
                        />
                        // <input
                        //     type="checkbox"
                        //     checked={row.values.individual}
                        //     onChange={(e) => {
                        //         update(row.index, e.target.checked, row.original.roleCategory, row.original.roleText);
                        //     }}
                        // />
                    );
                },
            },

            {
                Header: (
                    <div className="main-container ptb15 mw300">
                        Compare Designation
                        &nbsp;
                        &nbsp;
                        <Select
                            id="select"
                            native
                            // defaultValue="selectEmployee"
                            className="indvSelWidth"
                            value={compareDesignation.toString()}
                            onChange={(e) => {
                                setCompareDesignation(e.target.value.split(','));
                            }}
                        >
                            {/* <option value="selectEmployee" hidden>Select Employee</option> */}
                            {data.map((rows) => {
                                // console.log("rows", rows);
                                let rowsss = [];
                                if (rows.roleCategory != "Ultimate Client") {
                                    rowsss.push(rows);
                                }
                                // console.log("rowsss", rowsss[0] && rowsss[0].roleText);
                                return rowsss[0] && rowsss[0].roleText.map((roleText) => {
                                    // console.log("roleText", roleText);
                                    return (
                                        <option
                                            key={[rows.roleCategory, roleText.roleText].toString()}
                                            value={[rows.roleCategory, roleText.roleText].toString()}
                                        >
                                            {roleText.roleText} ({roleText.roleAlias})
                                        </option>
                                    )
                                });
                            })}
                        </Select>
                    </div>
                ),
                accessor: 'desination',
                Cell: ({ row }) => {
                    return <Checkbox checked={row.values.desination} disabled readOnly />;
                    // <input type="checkbox" checked={row.values.desination} disabled readOnly />;
                },
            }
        );

        setColumn(column);
    }, [data, compareDesignation, employee, update]);

    useMemo(() => {
        const tableData = [];

        data.forEach((role) => {
            if (role.roleCategory === compareDesignation[0])
                role.roleText.forEach((roleText) => {
                    if (roleText.roleText === compareDesignation[1])
                        roleText.feature.forEach((feature) => {
                            const featIndex = employee.roleText[0].feature.findIndex((feat) => {
                                return feat.featureText === feature.featureText;
                            });

                            const x = [];
                            if (featIndex !== -1)
                                feature.subFeatures.forEach((subFeature) => {
                                    const subFeatIndex = employee.roleText[0].feature[featIndex].subFeatures.findIndex((subfeat) => {
                                        return subfeat.subFeatureText === subFeature.subFeatureText;
                                    });

                                    if (subFeatIndex !== -1)
                                        x.push({
                                            roleCategory: employee.roleCategory,
                                            roleText: employee.roleText[0].roleText,
                                            features: feature.featureText,
                                            sub_features: subFeature.subFeatureText,
                                            desination: subFeature.isActive,
                                            individual: employee.roleText[0].feature[featIndex].subFeatures[subFeatIndex].isActive,
                                        });
                                });
                            tableData.push(...x);
                        });
                });
        });

        const tableData2 = [];

        tableData.forEach((row) => {
            const index = tableData.findIndex((row1) => row1.features === row.features && row1.sub_features === row.sub_features);

            tableData2[index] = tableData2[index] ? { ...tableData2[index], ...row } : row;
        });

        setTableData(tableData2);
    }, [data, compareDesignation, employee]);

    return (
        <div className="container-fluid" >

            {loading ? (<LoaderPopUp showLoader={loading} />)
                //  (
                //     <h1>
                //         <i>Loading.................</i>
                //     </h1>
                // ) 
                : (
                    ''
                )}
            {/* Select IMC <br />
                    <select className="itecInputBox indvSelect" name="tennantName" onChange={setImc} value={selectedImc}>
                        <option value="">Select IMC</option>
                        {allImcsOptions(AllImcs)}
                    </select>{' '}
                    <br />
                    <br />
                    Select Employee <br />
                    <select className="itecInputBox indvSelect" name="empId" onChange={getEmplDetails}>
                        <option value="">Select Employee</option>
                        {allImcEmpOptions(AllImcEmp)}
                    </select> */}
            <Grid container spacing={3} className="main-container w100i plr17">
                {usertype !== "Admin" ?
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="imc" shrink>
                                Select IMC
                                </InputLabel>
                            <Select
                                native
                                className="bottom"
                                name="tennantName"
                                onChange={setImc}
                                value={selectedImc}
                            >
                                <option value="">Select IMC</option>
                                {allImcsOptions(AllImcs)}
                            </Select>
                        </FormControl>
                    </Grid>
                    : ''}
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="sorp" shrink>
                            Select Employee
                            </InputLabel>
                        <Select
                            native
                            className="bottom"
                            name="empId"
                            onChange={
                                usertype === "Admin" ? getEmplDetailsCore :
                                    getEmplDetails}
                        >
                            <option value="">Select Employee</option>

                            {allImcEmpOptions(AllImcEmp)}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            {/* <select
          onChange={e => changeEmployee(e.target.value)}
          value={employee.empId}
        >
          {employeeData.map(emp => (
            <option key={emp.empId} value={emp.empId}>
              {emp.empId}
            </option>
          ))}
        </select> */}
            {/* <hr /> */}
            <div className="col-md-12">
                <GeneralTable column={tableColumn} data={tableDatas} />
            </div>
            {/* <hr /> */}
            {errorsDisplay()}
            <div className="m20">
                <Button variant="contained" color="primary" className="btnMtrx" onClick={save} disabled={buttonDissable} >
                    Update Matrix
                    </Button>
            </div>


        </div >
    );
}

export default PremissionTable;
